import {isAndroid, isIOS} from 'react-device-detect';
import {isWebview} from '@/utils/channel';

export type SoopBridgePayload = {
  action: string;
  value: unknown;
};

/**
 * 안드로이드 브릿지 메서드 호출 가능 여부를 확인합니다.
 * @param action 호출할 브릿지 액션 이름
 */
const canInvokeAndroidBridge = (action: string): boolean => {
  try {
    const androidBridge = window.SoopBridge as
      | Record<string, ((value: unknown) => void) | undefined>
      | undefined;
    return typeof androidBridge?.[action] === 'function';
  } catch {
    return false;
  }
};

/**
 * 앱 웹뷰에서 SoopBridge를 호출합니다.
 * @param payload 브릿지에 전달할 action과 value
 */
export const callSoopBridge = (payload: SoopBridgePayload): void => {
  if (!isWebview) {
    return;
  }

  if (isIOS && window.webkit?.messageHandlers?.SoopBridge?.postMessage) {
    try {
      window.webkit.messageHandlers.SoopBridge.postMessage(payload);
    } catch (error) {
      console.warn('[SoopBridge] invoke failed', error);
    }
    return;
  }

  if (isAndroid && canInvokeAndroidBridge(payload.action)) {
    try {
      const androidBridge = window.SoopBridge as
        | Record<string, ((value: unknown) => void) | undefined>
        | undefined;
      androidBridge?.[payload.action]?.(payload.value);
    } catch (error) {
      console.warn('[SoopBridge] invoke failed', error);
    }
  }
};
